module.exports = {
  urls: {
    app: 'http://localhost:8082',
    blog: 'https://blog.hackedu.com',
    cdn: 'https://cdn.hackedu.io',
    control: 'https://control.hackedu.dev',
    hacker: 'http://localhost:5003',
    quiz: 'http://localhost:5005',
    samy: 'https://samy.hackedu.dev',
    testengine: 'http://localhost:5007',
    www: 'http://localhost:8081',
  },
  aws: {
    region: 'us-east-1',
    identityPoolId: 'us-east-1:db591916-a591-4612-85e9-972836b966ae',
  },
  cognito: {
    authData: {
      ClientId: 'i78kjordr8ijhnnhf92sm5p24',
      AppWebDomain: 'auth.hackedu.dev',
      TokenScopesArray: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
      RedirectUriSignIn: 'http://localhost:8082/auth',
      RedirectUriSignOut: 'http://localhost:8082',
      UserPoolId: 'us-east-1_SlBDp9xy2',
      AdvancedSecurityDataCollectionFlag: false,
    },
  },
  saml: {
    checkDomainAssociationUri: 'http://localhost:5004/domain',
  },
  segment: {
    key: 'tfI02bSk23cxAsMsrMDde4xv57FsHjrF',
  },
  stripe: {
    key: 'pk_test_WysZSWBVn6L0XNh4fUqx3NFZ',
  },
}
